// 应用案例
import { useRef, useState } from 'react'

import { AnimateBox } from '../../components/animate-box'
import { Pack } from '../../components/pack'

import type { IndustryTag, PageContent } from '../../pageContents'

interface SectionCProps {
  title: string
  industryTags: IndustryTag[]
  industryContentsList: PageContent[]
}
export const SectionC = ({ title, industryTags, industryContentsList }: SectionCProps) => {
  const [activeTag, setActiveTag] = useState(industryTags[0].name)
  const el = useRef<HTMLDivElement>(null)
  const handleClick = (type: string) => {
    const size = (573 + 20) * 3
    if (type === 'l') {
      el.current?.scrollBy({
        left: -size,
        behavior: 'smooth'
      })
    } else {
      el.current?.scrollBy({
        left: size,
        behavior: 'smooth'
      })
    }
  }

  const grepData = industryContentsList.filter(item => item.tag === activeTag)
  return (
    <>
      <div className='title-box'>
        <AnimateBox tagName='h2'>{title}</AnimateBox>
        <AnimateBox animateDelay={0.5} tagName='p'>
          在航空航天、汽车、工业控制等重点行业实现规模化应用，支撑从模型在环到硬件在环的测试验证工程实践
        </AnimateBox>
      </div>
      <AnimateBox animateDelay={0.8} className='tabs-com'>
        {industryTags.map(item => {
          const { name, id } = item
          const className = activeTag === name ? 'active' : ''
          const key = id + '1'
          return (
            <button
              className={className}
              key={key}
              onClick={() => {
                setActiveTag(name)
              }}
            >
              {name}
            </button>
          )
        })}
      </AnimateBox>

      <div className='scroll-c' ref={el}>
        <ul className='inner'>
          {grepData.map((item, index) => {
            const { tag, title, id, descriptions, thumbnail } = item
            const url = `/industry/${id}`
            if (tag !== activeTag) {
              return null
            }
            const keyId = id + index
            const classArr = ['card', 'h600']
            if (grepData.length === 1) {
              classArr.push(...['w1420'])
            }
            if (grepData.length === 2) {
              classArr.push(...['w700'])
            }
            if (grepData.length >= 3) {
              classArr.push(...['w460'])
            }
            classArr.push('p162-334')

            return (
              <AnimateBox
                animateDelay={0.5 + (index % 4) * 0.2}
                className={classArr.join(' ')}
                key={keyId}
              >
                <div className='img h350'>
                  <div
                    className='pic'
                    style={{
                      backgroundImage: `url(${thumbnail})`
                    }}
                  />
                </div>
                <div className='info'>
                  <h5 className='clamp-2'>
                    <a href={url}>{title}</a>
                  </h5>
                  <p className='clamp-2'>{descriptions}</p>
                  <a className='look-more b40' href={url}>
                    <span>了解更多</span>
                  </a>
                </div>
              </AnimateBox>
            )
          })}
        </ul>
      </div>

      <Pack className='btnlr-com' if={grepData.length > 3}>
        <button
          className='arrow-icon light-left'
          onClick={() => {
            handleClick('l')
          }}
        />
        {/* <button
          className='arrow-icon light-left-grey'
          onClick={() => {
            handleClick('l')
          }}
        /> */}
        <button
          className='arrow-icon light-right'
          onClick={() => {
            handleClick('r')
          }}
        />
        {/* <button
          className='arrow-icon light-right-grey'
          onClick={() => {
            handleClick('r')
          }}
        /> */}
      </Pack>
    </>
  )
}
